const ImplementationType = {
  Ic: "IC",
  Cr: "CR",
  Hon: "HON"
};
const SectionStatus = {
  Active: "ACTIVE",
  Archived: "ARCHIVED"
};
const TermTermType = {
  Fixed: "FIXED",
  Rolling: "ROLLING"
};
export {
  ImplementationType,
  SectionStatus,
  TermTermType
};
